/* tslint:disable */
/* eslint-disable */
/**
 * Careplatform Meeting API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: bjorn.naeslund@r2m.se
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * Requst object containing the ids of the meetings whose current status
 * @export
 * @interface CheckMeetingStatusRequest
 */
export interface CheckMeetingStatusRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof CheckMeetingStatusRequest
     */
    meetingIds: Array<string>;
}

export function CheckMeetingStatusRequestFromJSON(json: any): CheckMeetingStatusRequest {
    return CheckMeetingStatusRequestFromJSONTyped(json, false);
}

export function CheckMeetingStatusRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CheckMeetingStatusRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'meetingIds': json['meetingIds'],
    };
}

export function CheckMeetingStatusRequestToJSON(value?: CheckMeetingStatusRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'meetingIds': value.meetingIds,
    };
}


